import React, { FC } from 'react';
import { Box } from '../../../atoms/Box';
import { Unit } from '../../../core/Unit';
import { AccordionItem, IAccordionItemProps } from '../_Item/AccordionItem';

/**
 * Оборачивание в Unit вынесено в отдельный компонент, так как из-за перерендера AccordionItem
 * при открытии и закрытии срабатывало событие показа юнита
 */
export const AccordionItemUnit: FC<IAccordionItemProps> = (props) => {
  const entityCtx = props.entityId ? { entityId: props.entityId, objectId: props.id } : undefined;
  return (
    <Unit id={'AccordionItem'} entityCtx={entityCtx}>
      <Box fullWidth>
        <AccordionItem {...props} />
      </Box>
    </Unit>
  );
};
